import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  SubscriptionPlanData,
  SubscriptionPlan,
} from '../../../@core/interfaces/common/CalorieFriend/subscriptionPlan';

@Injectable()
export class SubscriptionFormResolver implements Resolve<Observable<any>> {
  constructor(private subscriptionsService: SubscriptionPlanData) {}

  resolve(route: ActivatedRouteSnapshot) {
    const observer = route.params.id
      ? this.subscriptionsService.get(route.params.id)
      : of(this.getEmptySubscription());

    return observer.pipe(
      map((subscription) => {
        return {
          subscription,
        };
      }),
    );
  }

  private getEmptySubscription(): SubscriptionPlan {
    return {
      id: undefined,
      planType: 0,
      planName: '',
      planCode: '',
      priceId: '',
      patientsCount: 0,
      price: 0,
      isFreePlan: false,
      hasAssessments: false,
      hasBranding: false,
      hasPlanChoices: false,
    };
  }
}
